import { useEffect, useState } from "react";
import { useLabReportFilterListAPI } from "@/app/hooks/api_hooks/LabReport/useLabReportFilterListAPI";
import LabReportTableComponent from "@components/routes/auth_routes/LabReportManagement/LabReportTableComponent";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { ROUTES } from "@/app/routes";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useDispatch } from "react-redux";
import { setLabReportListFilter } from "@/app_redux/reducers/slices/auth/lab_report_slice";

export interface ILabReportTabProps {
  date: string;
}

const LabTestTab = () => {
  const { execute: labReportApi } = useLabReportFilterListAPI();

  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { customerId } = routeState.state as ICustomerProfileState;
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);

  const today = new Date();
  const twoWeeksFromNow = new Date();
  twoWeeksFromNow.setDate(today.getDate() - 30);
  const [selectionDate, setSelectionDate] = useState({
    startDate: twoWeeksFromNow,
    endDate: today,
    key: "selectionDate",
  });
  const startDate = new Date(selectionDate.startDate);
  const endDate = new Date(selectionDate.endDate);
  const startYear = startDate.getFullYear();
  const startMonth = (startDate.getMonth() + 1).toString().padStart(2, "0");
  const startDay = startDate.getDate().toString().padStart(2, "0");
  const endYear = endDate.getFullYear();
  const endMonth = (endDate.getMonth() + 1).toString().padStart(2, "0");
  const endDay = endDate.getDate().toString().padStart(2, "0");
  const formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
  const formattedEndDate = `${endYear}-${endMonth}-${endDay}`;

  const dispatch = useDispatch();

  useEffect(() => {
    if (!customerId) return;
    const payload = {
      // start_date: formattedStartDate,
      // end_date: formattedEndDate,
      start_date: null,
      end_date: null,
      clinic_ids: [],
      status_ids: [],
      customer_id: customerId,
      type: 3,
    };

    labReportApi(payload);
    dispatch(setLabReportListFilter(payload));
  }, [
    customerId,
    formattedStartDate,
    formattedEndDate,
  ]);

  return (
    <div className="px-0">
      <div className="sm:flex sm:items-center text-sm">
        <div className="sm:flex-auto px-2 mb-2 sm:pb-4 sm:px-2">
          <h1 className="text-sm font-semibold leading-6 text-gray-900">
            Lab Reports
          </h1>
        </div>
      </div>
      <div className="sm:-mt-5 px-2">
        <LabReportTableComponent scrollMode="table" />
      </div>
    </div>
  );
};

export default LabTestTab;
